/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSuperstackingSettingsInternal} from '../api'

 export const useQueryGetSuperstackingSettingsInternal = createReactQueryHook('getSuperstackingSettingsInternal', getSuperstackingSettingsInternal)
